// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Next__Head = require("../../../reason/next/Next__Head.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");

function setTitle(title) {
  Stdlib_Option.forEach(Webapi__Dom__Document.asHtmlDocument(document), a => {
    a.title = title;
  });
}

function usePageTitle(title) {
  React.useEffect(() => {
    setTitle(title);
    return () => setTitle("TAN: The only online network built exclusively for verified top agents");
  }, [title]);
}

function PageTitle(props) {
  let title = props.title;
  return JsxRuntime.jsxs(Next__Head.make, {
    children: [
      JsxRuntime.jsx("title", {
        children: title
      }),
      JsxRuntime.jsx("meta", {
        content: title,
        property: "og:title"
      }, "title")
    ]
  });
}

let make = PageTitle;

let $$default = PageTitle;

exports.make = make;
exports.usePageTitle = usePageTitle;
exports.default = $$default;
exports.__esModule = true;
/* react Not a pure module */
